import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({
  fontSizes, fontWeights, borderRadiuses, palette, lineHeights,
}: Theme) => ({
  iconWrapper: {
    marginBottom: 10,
    '& img': {
      display: 'block',
      width: 140,
    },
  },
  actionLink: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '18rem',
    marginTop: 12,
    padding: '8px 40px',
    borderRadius: borderRadiuses.xl,
    color: palette.common.white,
    background: palette.primary.main,
    fontSize: fontSizes.sm,
    lineHeight: lineHeights.md,
    textDecoration: 'none',
  },
  title: {
    margin: '8px 0',
    fontSize: fontSizes.md,
    lineHeight: lineHeights.lg,
    fontWeight: fontWeights.medium,
    textAlign: 'center',
  },
  description: {
    margin: 0,
    fontSize: fontSizes.sm,
    lineHeight: lineHeights.md,
    textAlign: 'center',
  },
  link: {
    color: palette.primary.dark,
  },
  index: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 28,
    height: 28,
    borderRadius: borderRadiuses.xxl,
    background: palette.primary.main,
    color: palette.common.white,
    fontSize: fontSizes.lg,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingLeft: '2rem',
    paddingRight: '2rem',
  },
  block: {
    display: 'block',
  },
  list: {
    listStyle: 'disc',
  },
  listItem: {},
  image: {
    display: 'block',
    maxWidth: '100%',
    margin: '0.675rem auto 0',
  },
  imageFirst: {
    marginBottom: '1.25rem',
  },
  indexIcon: {},
}));
